import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const load = async () => {
    if (!user) {
      setIds([]);
      return;
    }
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.map((p) => p.id));
    } catch {
      setIds([]);
    }
  };

  useEffect(() => {
    load();
  }, [user]);

  const toggle = async (productId) => {
    if (!user) return { needAuth: true };
    const { data } = await api.post(`/wishlist/${productId}`);
    setIds(data.wishlist);
    return { needAuth: false };
  };

  const has = (id) => ids.includes(id);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length, reload: load }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
